export const errorPageContent: {
  [code: number]: {
    header?: string;
    message: string;
  };
} = {
  400: {
    header: "Bad Request",
    message: "The page you requested could not be found",
  },
  404: {
    header: "Oops! Page Not Found",
    message:
      "We searched high and low but couldn't find the pages you're looking for",
  },
  405: { header: "Error", message: "Method Not Allowed" },
  500: {
    header: "Sorry! Something Went Wrong",
    message:
      "A ticket has been submitted to AreaHub's engineering team and will be fixed shortly! In the meantime, try exploring one of the following!",
  },
  402: {
    header: "Payment Required",
    message:
      "The requested resource is not available. Please refer to AreaHub Pro Reports on the pricing page for more information.",
  },
  401: {
    header: "Unauthorized",
    message: "You must sign in / sign up to perform this action!",
  },
};
